import type { Translations } from './types';

const es: Translations = {
    next: 'Siguiente',
    storyReadPrompt: 'Por favor, lee primero la historia.',
    backToStory: '← Volver a la historia',
    nextArrow: 'Siguiente →',
    finishAssessment: 'Finalizar evaluación →',
    common_step: 'Paso',
    questionsStory1: 'Preguntas — Historia 1',
    questionsStory2: 'Preguntas — Historia 2',
    lastSetOfQuestions: '¡Últimas preguntas — casi terminado! 🎉',
    typeAnswerHere: 'Escribe tu respuesta aquí...',
    backCountSingular: '📖 Volviste {n} vez a esta página para releer la historia.',
    backCountPlural: '📖 Volviste {n} veces a esta página para releer la historia.',

    assessmentComplete: '¡Evaluación completa! 🎉',
    assessmentSubtitle: 'Has dado un paso importante hacia la comprensión de las dificultades de aprendizaje',
    returnToHome: 'Volver al inicio',
    assessmentSuccessfullyCompleted: 'Evaluación completada con éxito',
    amazingJob: '¡Trabajo increíble!',
    youCrushedIt: '¡Lo has conseguido! Aquí están tus logros:',
    whatsNext: '¿Qué viene ahora?',
    getReadyForResults: 'Prepárate para recibir tus resultados personalizados',
    youDidIt: '¡Lo has hecho!',
    youDidItDesc: 'Tu compromiso con la comprensión de las dificultades de aprendizaje es verdaderamente inspirador. Donde otros habrían abandonado, tú lo has completado hasta el final.',

    heroLine1: 'DISLEXIA',
    heroLine2: 'CRIBADO',
    heroTagline: 'en una sola sesión',
    heroSubtitle:
      'Una evaluación multimodal en el navegador que te da un informe escrito en cuanto terminas: sin ir a la clínica, sin lista de espera, sin equipos especiales.',
    heroBetaLabel: 'BETA',
    startAssessment: 'Comenzar',
    trustedBy: 'De confianza para educadores e investigadores de todo el mundo',

    pfp_privacyBadge: 'Privacidad y cumplimiento',
    pfp_privacyHeading: 'Nos tomamos en serio la protección de datos con pleno cumplimiento de GDPR y MDR',
    pfp_formBadge: 'Iniciar evaluación',
    pfp_ctaHeading: 'Evaluación de dislexia',
    pfp_ctaDesc: 'Únete a miles de personas que descubren información única sobre su estilo de lectura a través de nuestra evaluación impulsada por IA.',
    pfp_ctaFooter: 'Sin límite de tiempo • A tu ritmo • 100% confidencial',
    pfp_whyTitle: '¿Por qué DysTest?',
    pfp_whySubtitle: 'Descubre por qué nuestra evaluación impulsada por IA es la solución más precisa y fiable',
    pfp_whyDesc: 'DysTest combina más de 20 años de experiencia profesional en investigación sobre dislexia con experiencia vivida. Al comprender cómo procesan los textos los lectores disléxicos y neurotípicos, nuestra IA reconoce los sutiles patrones de lectura que las pruebas tradicionales pasan por alto.',
    pfp_feature1Title: 'Seguimiento ocular, dinámica de teclas e información multilingüe',
    pfp_feature1Desc: 'La IA avanzada analiza los movimientos oculares, las señales faciales y la escritura, en cualquier idioma. DysTest se adapta de forma inteligente para ofrecer resultados precisos y personalizados a los usuarios multilingües.',
    pfp_feature2Title: 'Resultados inmediatos y prácticos',
    pfp_feature2Desc: 'Obtén información clara y basada en la ciencia en minutos. Nuestros informes traducen datos complejos en recomendaciones fácilmente comprensibles.',
    pfp_feature3Title: 'Privacidad y cumplimiento primero',
    pfp_feature3Desc: 'Tus datos se cifran, anonimizan y gestionan según los más altos estándares éticos, con pleno cumplimiento de GDPR y MDR.',
    pfp_feature4Title: 'Diseño accesible y centrado en las personas',
    pfp_feature4Desc: 'DysTest te permite hacer la prueba a tu ritmo: tranquilo, intuitivo y sin presión. Redefine cómo se detectan y apoyan las dificultades de aprendizaje.',
    pfp_finalCtaDesc: 'Comienza hoy tu evaluación personal de dislexia impulsada por IA, diseñada para comprender cómo lees, no solo qué lees.',

    hiw_badge: 'Proceso sencillo de 8 pasos',
    hiw_heading: 'Cómo funciona la evaluación',
    hiw_subtext: 'Desde el registro hasta el informe detallado de evaluación de dislexia, completamente en el navegador, sin descargas.',
    hiw_step1Title: 'Registro',
    hiw_step1Desc: 'Introduce tu nombre, edad e idioma preferido. No se necesita cuenta: menos de 2 minutos.',
    hiw_step2Title: 'Calibración ocular',
    hiw_step2Desc: 'Sigue 16 puntos animados. El rastreador de iris de IA aprende tu reconocimiento visual único.',
    hiw_step3Title: 'Palabras e Imágenes',
    hiw_step3Desc: 'Asocia palabras con sus imágenes mientras medimos la velocidad de reconocimiento y el procesamiento visuo-fonológico.',
    hiw_step4Title: 'Test de velocidad RAN',
    hiw_step4Desc: 'Nombra en voz alta una secuencia de colores u objetos lo más rápido posible. Mide la fluidez de recuperación.',
    hiw_step5Title: 'Historias y Preguntas',
    hiw_step5Desc: 'Lee dos historias adecuadas para la edad y responde preguntas de comprensión. Se registran los movimientos oculares y los parpadeos.',
    hiw_step6Title: 'Escritura de palabras',
    hiw_step6Desc: 'Escribe palabras de memoria. El tiempo de pulsaciones y los patrones de error revelan la ortografía y el procesamiento motor.',
    hiw_step7Title: 'Retroalimentación',
    hiw_step7Desc: 'Comparte tu experiencia y preocupaciones. Este contexto ayuda a calibrar la interpretación clínica.',
    hiw_step8Title: 'Obtén resultados',
    hiw_step8Desc: 'Recibe un informe detallado con indicadores de riesgo de dislexia, mapas de calor visuales y métricas de lectura.',

    pf_whoTaking: '¿Quién va a hacer la prueba?',
    pf_myself: 'Yo mismo',
    pf_myselfAge: 'Edad 13+',
    pf_child: 'Un niño',
    pf_childAgeRange: 'Edad 5-12',
    pf_verifyEmailTitle: 'Verifica tu correo electrónico',
    pf_parentalConsentStepTitle: 'Consentimiento parental',
    pf_verifyEmailDesc: 'Introduce el código enviado a tu correo electrónico para completar el registro',
    pf_consentDesc: 'Por favor, revisa y proporciona tu consentimiento para el tratamiento de datos',
    pf_yourName: 'Nombre del participante *',
    pf_yourNamePlaceholder: 'Introduce tu nombre completo',
    pf_emailAddress: 'Dirección de correo electrónico *',
    pf_assessmentLanguage: 'Idioma de la evaluación',
    pf_emailPlaceholder: 'Introduce tu correo electrónico',
    pf_invalidEmail: 'Por favor, introduce una dirección de correo electrónico válida',
    pf_yourAge: 'Tu edad *',
    pf_selectAge: 'Selecciona tu edad',
    pf_yearsUnit: 'años',
    pf_dyslexiaTested: '¿Has sido evaluado por dislexia? *',
    pf_iAmDyslexic: 'Sí, estoy diagnosticado oficialmente',
    pf_iAmNotDyslexic: 'Evaluado y no disléxico',
    pf_notKnown: 'No lo sé',
    pf_parentName: 'Nombre del padre/madre *',
    pf_parentNamePlaceholder: 'Introduce el nombre del padre/madre',
    pf_childName: 'Nombre del niño *',
    pf_childNamePlaceholder: 'Introduce el nombre del niño',
    pf_childAgeLabel: 'Edad del niño *',
    pf_selectChildAge: 'Selecciona la edad del niño',
    pf_childDyslexiaTested: '¿Ha sido evaluado tu hijo por dislexia? *',
    pf_yesHasDyslexia: 'Sí, diagnosticado oficialmente',
    pf_yesNoDyslexia: 'Evaluado y no disléxico',
    pf_noNotTested: 'No, nunca ha sido evaluado',
    pf_nativeLangQuestion: '¿Qué idioma hablas en casa?',
    pf_browserLangDetected: 'Idioma del navegador detectado:',
    pf_availableInSystem: '✓ Disponible en nuestro sistema',
    pf_yesNative: 'Sí',
    pf_othersNative: 'Otros',
    pf_specifyNative: 'Por favor, especifica tu lengua materna *',
    pf_selectNativePlaceholder: 'Selecciona tu lengua materna',
    pf_selectNativeError: 'Por favor, selecciona tu lengua materna',
    pf_nativeLangNote: 'Esto nos ayuda a proporcionarte resultados de evaluación más precisos basados en tu perfil lingüístico. Tu idioma del navegador ({lang}) se detectó automáticamente; nunca usamos tu dirección IP para la detección del idioma.',
    pf_forYourChild: 'Para tu hijo',
    pf_childExplanation: 'El ordenador observa cómo lees (tu cara, ojos y escritura) para entender tu estilo de lectura. Tus datos están seguros. Tus padres han dado permiso y puedes parar cuando quieras.',
    pf_parentalConsentLabel: 'Consentimiento parental *',
    pf_parentalConsentText: 'Doy mi consentimiento para el tratamiento de los datos de movimientos oculares, expresiones faciales e interacciones con el teclado de mi hijo (o míos propios) para la evaluación de la dislexia, de conformidad con el RGPD y el MDR.',
    pf_dataConsentLabel: 'Consentimiento de tratamiento de datos y política de privacidad *',
    pf_dataConsentText: 'Consiento el tratamiento de mis datos personales con fines de detección.\nHe leído y acepto la Política de Privacidad y los Términos del Servicio.',
    pf_consentPre: 'Acepto la',
    pf_consentPrivacyLink: 'Política de Privacidad',
    pf_consentBetween: 'y los',
    pf_consentTermsLink: 'Términos del Servicio',
    pf_consentPost: ', incluido el tratamiento de datos con fines de detección.',
    pf_emailFailedTitle: 'Error al enviar el correo electrónico',
    pf_checkYourEmail: 'Comprueba tu correo electrónico',
    pf_emailSentDesc: 'Hemos enviado un código de verificación de 6 dígitos a {email}. Por favor, comprueba tu bandeja de entrada e introduce el código a continuación.',
    pf_emailFailedDesc: 'Error al enviar a {email}.',
    pf_tryAgain: 'Intentar de nuevo',
    pf_sendingEmail: 'Enviando...',
    pf_verificationCodeLabel: 'Código de verificación *',
    pf_enterCodePlaceholder: 'Introduce el código de 6 dígitos',
    pf_codeExpiry: 'Introduce el código de 6 dígitos de tu correo electrónico. El código caduca en 15 minutos.',
    pf_resendCode: '¿No has recibido el código? Haz clic para reenviar',
    pf_sendingNewCode: 'Enviando nuevo código...',
    pf_continue: 'Continuar',
    pf_continueToConsent: 'Continuar al consentimiento',
    pf_verifyEmailBtn: 'Verificar correo electrónico',
    pf_verifying: 'Verificando...',
    pf_processing: 'Procesando...',
    pf_importantNotice: 'Aviso importante',
    pf_disclaimer: 'DysTest es una herramienta de detección digital diseñada para apoyar la identificación temprana y la comprensión del aprendizaje. No proporciona un diagnóstico médico. Para obtener un diagnóstico oficial o asesoramiento clínico, consulta a profesionales de la salud cualificados.',
            cg_readingAssessment: 'Evaluación de lectura',
    cg_whatsNext: 'Esto es lo que viene a continuación',
    cg_twoSections: 'Dos secciones cortas — lee una historia y luego responde algunas preguntas',
    cg_readStory: 'Lee la historia',
    cg_readStoryDesc: 'Tómate tu tiempo — lee a tu propio ritmo',
    cg_answerQuestions: 'Responde algunas preguntas',
    cg_answerQuestionsDesc: 'Escribe tus respuestas con tus propias palabras — no hay respuestas correctas o incorrectas',
    cg_exampleQuestion: '¿Qué pasó al principio de la historia?',
    cg_exampleAnswer: 'El niño fue al parque…',
    cg_startReading: 'Empezar a leer',
    cg_warmupGame: 'Juego de calentamiento',
    cg_matchHeading: 'Relaciona la palabra con la imagen',
    cg_matchSubtitle: 'Haz clic en una tarjeta de palabra y luego en la imagen correspondiente para completar el par',
    cg_startMatching: '¡Empezar!',
    cg_demoWord: 'gato',
    cg_allMatched: '¡Todos emparejados!',
    cg_heatmapContinuing: 'Tu mapa de calor visual se muestra a continuación: continuando pronto…',
    cg_lookAtTarget: '👁️ ¡Mirando el objetivo!',
    cg_lookAtDot: 'Mira el punto rojo',
    cg_sRemaining: 'segundos restantes',
    cg_skipFixation: 'Saltar fijación',
    cg_correct: '✓ ¡Correcto!',
    cg_tryAgain: '✗ Intentar de nuevo',
    cg_liveMetrics: 'Métricas en vivo',
    cg_blinks: 'Parpadeos',
    cg_matched: 'Emparejados',
    cg_errors: 'Errores',
    fpc_instruction: 'Mira cada punto',
    fpc_dotsTotal: 'puntos en total — mira directamente cada punto y mantén la mirada. Se captura automáticamente.',
    fpc_cancelCalibration: 'Cancelar calibración',
    fpc_clickMe: '¡Haz clic en mí!',
    fpc_eyeTrackingStarting: 'El seguimiento ocular está comenzando: ¡ya puedes hacer clic!',
    fpc_calibrationComplete: '¡Calibración completa!',
    fpc_trainingSamples: '{n} muestras de entrenamiento registradas',
    fpc_allPointsDone: '¡Todos los puntos completados!',
    fpc_pointOf: 'Punto {current} de {total}',
    fpc_training: 'Entrenamiento',
    fpc_inactive: 'Calibration inactive',
    fpc_savingCalibration: 'Guardando calibración…',
    fpc_moveEyes: 'Mueve tus ojos hacia el punto…',
    fpc_noFace: '⚠️ No se detecta ningún rostro — centra tu rostro en la cámara',
    fpc_missingIrisTitle: '⚠️ Faltaron datos del iris en demasiados puntos',
    fpc_missingIrisBody: 'Se omitieron varios puntos de calibración porque no se detectaron puntos de referencia del iris.',
    fpc_lowAccuracyTitle: 'Precisión inferior a la esperada',
    fpc_lowAccuracyBody: 'El error de calibración es mayor de lo ideal. Esto puede reducir la precisión del seguimiento de la mirada.',
    fpc_redoCalibration: 'Rehacer calibración',
    fpc_continueAnyway: 'Continuar de todas formas',
    fpc_lookAtDot: 'Mira directamente al punto',
    fpc_dotReady: '✓ Punto capturado — avanzando…',
    fpc_keepLooking: 'Sigue mirando el punto — se captura automáticamente',
    fpc_captured: '✓ ¡Capturado! Pasando al siguiente…',
    fpc_checkingAccuracy: 'Comprobando precisión',
    fpc_valGotIt: '¡Listo! Pasando al siguiente…',
    fpc_valHoldStill: 'Quieto — recopilando datos…',
    fpc_valLookDot: 'Mira el punto — se vuelve naranja cuando está listo',
    fpc_valCheck: 'COMP',

    acp_welcome: '¡Bienvenido, {name}!',
    acp_setupSubtitle: 'Configuremos tu evaluación',
    acp_setupVerification: 'Verificación de configuración',
    acp_setupStepsDesc: 'Completa todos los pasos para desbloquear la evaluación',
    acp_step1Title: 'Cámara activa',
    acp_step1Desc: 'La cámara se inicia automáticamente, no se requiere ninguna acción',
    acp_step2Title: 'Verificación de cámara',
    acp_step2Desc: 'Verifica la calidad y estabilidad de la cámara',
    acp_step3Title: 'Prueba de escritura',
    acp_step3Desc: 'Verifica la funcionalidad del teclado',
    acp_step4Title: 'Calibración ocular',
    acp_step4Desc: 'Calibra el sistema de seguimiento ocular',
    acp_eyeTrackingActive: '✓ Seguimiento ocular activo',
    acp_eyeTrackingError: '⚠ Error de seguimiento ocular:',
    acp_startingEyeTracking: '⏳ Iniciando seguimiento ocular...',
    acp_cameraReady: '👁 Cámara lista',
    acp_waitingForCamera: '📷 La cámara se inicia automáticamente...',
    acp_stepDone: 'Completado',
    acp_stepInProgress: 'En progreso',
    acp_checkingCameraStability: 'Comprobando estabilidad de la cámara...',
    acp_cameraVerified: 'Cámara verificada ✓',
    acp_autoVerifyingCamera: 'Verificación automática de la cámara...',
    acp_waitingFaceDetection: 'Esperando detección de rostro...',
    acp_eyeTrackingStarting: 'Iniciando seguimiento ocular...',
    acp_calibrationInProgress: 'Calibración en progreso...',
    acp_eyeTrackingReady: 'Seguimiento ocular listo ✓',
    acp_startingCalibration: 'Iniciando calibración...',
    acp_distanceHint: 'Mantén la cara centrada y quieta, a no más de 60 cm de la pantalla',
    acp_distanceLabel: 'máx. 60 cm',
    acp_fpsTitle: 'Tu cámara va un poco lenta',
    acp_fpsBody: 'Ofrece {fps} imágenes por segundo; se necesitan al menos 10 para medir la mirada. Esto suele ayudar en segundos:',
    acp_fpsVeryLow: 'A esta velocidad, algunas medidas de los movimientos oculares quizá no sean útiles; las demás tareas siguen contando.',
    acp_fpsTipLight: 'Enciende más luz o colócate de cara a una ventana',
    acp_fpsTipCharger: 'Conecta el cargador (el ahorro de batería ralentiza el portátil)',
    acp_fpsTipApps: 'Cierra las videollamadas y otros programas pesados',
    acp_fpsCheckAgain: 'Comprobar de nuevo',
    acp_fpsChecking: 'Comprobando…',
    acp_fpsContinue: 'Continuar de todos modos',
    acp_preparingEyeTracking: 'Preparando seguimiento ocular...',
    acp_cameraPreview: 'Vista previa de la cámara',
    acp_noFaceDetected: 'No se detecta ningún rostro',
    acp_live: 'En vivo',
    acp_cameraVerifiedTitle: 'Cámara verificada ✓',
    acp_cameraReadyTitle: 'Cámara lista',
    acp_qualityCheckPassed: 'Comprobación de calidad superada',
    acp_optimizedForAssessment: 'Optimizado para la evaluación',
    acp_verifiedBadge: 'Verificado',
    acp_readyBadge: 'Listo',
    acp_assessmentMetrics: 'Métricas de evaluación',
    acp_faceDistance: 'Distancia del rostro',
    acp_goodDistance: 'Buena distancia para la evaluación',
    acp_searching: 'Buscando...',
    acp_lightLevel: 'Nivel de luz',
    acp_fps: 'FPS',
    acp_fpsExcellent: 'Frecuencia de fotogramas excelente',
    acp_fpsGood: 'Buena frecuencia de fotogramas',
    acp_fpsModerate: 'Frecuencia de fotogramas moderada',
    acp_fpsLow: 'Frecuencia de fotogramas baja',
    acp_fpsInitializing: 'Inicializando...',
    acp_faceDetection: 'Detección de rostro',
    acp_faceDetected: '✓ Detectado',
    acp_faceDetectedSub: 'Rostro detectado correctamente',
    acp_cameraQualityPassed: 'Comprobación de calidad de la cámara superada. Listo para el siguiente paso.',
    acp_visionWarnings: 'Advertencias visuales',
    acp_trackingMetrics: 'Métricas de seguimiento',
    acp_headPitch: 'Inclinación de la cabeza:',
    acp_headYaw: 'Giro de la cabeza:',
    acp_headRoll: 'Balanceo de la cabeza:',
    acp_gazePoint: 'Punto de mirada:',
    acp_emotion: 'Emoción:',
    acp_confidence: 'Confianza:',
    acp_trackingId: 'ID de seguimiento:',
    acp_faceId: 'ID de rostro:',
    acp_browser: 'Navegador:',
    acp_os: 'SO:',
    acp_camera: 'Cámara:',
    acp_resolution: 'Resolución:',
    acp_initializingTracking: 'Inicializando métricas de seguimiento...',
    acp_dataQuality: 'Calidad de datos',
    acp_dataQualityExcellent: 'Excelente',
    acp_dataQualityGood: 'Buena',
    acp_dataQualityFair: 'Aceptable',
    acp_dataQualityDetecting: 'Detectando...',
    acp_dataQualityExcellentDesc: 'Óptimo para la evaluación',
    acp_dataQualityGoodDesc: 'Bueno para la evaluación',
    acp_dataQualityFairDesc: 'Calidad aceptable',
    acp_dataQualityDetectingDesc: 'Analizando condiciones',
    acp_faceMeshPoints: 'Puntos de malla facial',
    acp_completeFaceMesh: 'Malla facial completa',
    acp_detecting: 'Detectando...',
    acp_typingTest: 'Prueba de escritura',
    acp_typeQwerty: 'Escribe {target} para verificar el teclado',
    acp_verifyKeyboard: 'Verifica la funcionalidad del teclado',
    acp_activeStatus: 'Activo',
    acp_lockedStatus: 'Bloqueado',
    acp_typeHere: 'Escribe aquí...',
    acp_typingCompleted: '✓ ¡Completado! Pasando al siguiente paso...',
    acp_keepTyping: 'Sigue escribiendo:',
    acp_remaining: 'restantes',
    acp_startTyping: 'Empieza a escribir las letras de arriba',
    acp_completeCameraVerification: 'Completa la verificación de la cámara para desbloquear',
    acp_lightingPerfect: 'Iluminación perfecta para la evaluación',
    acp_lightingSlightlyBright: 'Ligeramente brillante: reduce si es posible',
    acp_lightingTooBright: 'Demasiado brillante: reduce la luz o el brillo de la pantalla',
    acp_lightingSlightlyDim: 'Ligeramente oscuro: aumenta si es posible',
    acp_lightingTooDim: 'Demasiado oscuro: aumenta la luz',
    acp_positionFace: '👤 Coloca tu rostro frente a la cámara',
    acp_faceDetectedStarting: '✅ Rostro detectado: iniciando verificación...',
    acp_adjustDistance: 'Ajusta tu distancia de la cámara',
    acp_moveFarther: 'Aléjate de la cámara',
    acp_distanceInRange: 'La distancia se ve bien',
    pdg_moveCloser: 'Acércate más a la cámara',
    pdg_moveFarther: 'Aléjate de la cámara',
    pdg_dismiss: 'Descartar',
    acp_noData: 'Sin datos',
    acp_setupProgress: 'Progreso de configuración',
    acp_stepsComplete: '{n} de 4 pasos completados',
    acp_environment: 'Entorno',
    acp_checkingEllipsis: 'Comprobando…',
    acp_waitingEllipsis: 'Esperando…',
    acp_analysingConditions: 'Analizando las condiciones de la cámara…',
    acp_positionFaceCamera: 'Coloca tu rostro frente a la cámara',
    acp_faceAligned: 'Cara alineada',
    shared_stepOf: 'Paso {step} de {total}',
    shared_start: 'iniciar',
    cal_introHeading: 'CALIBRACIÓN',
    cal_introSubtitle: 'Sigue los puntos y mantén la cabeza quieta',
    story_introHeading: 'LECTURA Y PREGUNTAS',
    fpc_lookHere: '👆 Haz clic en el punto para continuar',
            pfp_chip_gdpr: 'Cumple RGPD',
    pfp_chip_mdr: 'Alineado MDR',
    pfp_chip_noData: 'Sin compartir datos',
    pfp_chip_languages: '8 Idiomas',
    kbv_header: 'Captura de dinámica de teclado',
    kbv_interKey: 'Intervalo entre teclas',
    kbv_typingSpeed: 'Velocidad de escritura',
        pfp_aiBadge: 'Herramienta de detección de dislexia con seguimiento ocular',
    pfp_whyBadge: 'Por qué DysTest',
    mat_missionBadge: 'Nuestra misión y tecnología',
    mat_eyeBadge: 'Seguimiento ocular',
    mat_kbdBadge: 'Análisis de pulsaciones',
    mat_ferBadge: 'Expresión facial',
    pfp_noBrowserFooter: 'Sin cuenta necesaria · Totalmente en el navegador · Resultados en <15 minutos',
    eye_viz_landmarks: '478 Puntos clave',
    eye_viz_irisFaceMesh: 'Iris + Malla facial',
    eye_viz_fps: '30 FPS en tiempo real',
    eye_viz_validation: 'Validación 9 + 4 puntos',
    eye_viz_calibration: 'Calibración clínica de 13 puntos',
    ran_anim_rapidNaming: 'Denominación rápida',
    ran_anim_predictor: '#1 indicador de dislexia',
    ran_anim_ageNormed: 'Puntuación por edad',
    ran_anim_zscore: 'puntuación z + percentil',
    acp_hideDetails: 'Ocultar detalles ▲',
    acp_showDetails: 'Mostrar detalles ▼',
    acp_moveCloser: 'Acércate',
    acp_headLabel: 'Cabeza',
    acp_setupTipsTitle: 'Consejos rápidos de configuración',
    acp_tip1: 'Siéntate a unos 50 cm de la pantalla',
    acp_tip2: 'Asegúrate de tener una iluminación uniforme y brillante en tu rostro',
    acp_tip3: 'Mantén la cabeza recta y mira directamente a la cámara',
    acp_tip4: 'Usa un entorno tranquilo para una mejor evaluación',
    acp_progressLabel: 'Progreso',

    priv_gdprTitle: 'Cumplimiento del RGPD',
    priv_gdpr1: 'Consentimiento parental verificable para usuarios menores de 13 años',
    priv_gdpr2: 'Minimización de datos y limitación de finalidad',
    priv_gdpr3: 'Derecho de acceso, rectificación y supresión de datos',
    priv_gdpr4: 'Tratamiento de datos transparente',
    priv_mdrTitle: 'Alineado con el MDR',
    priv_mdr1: 'Protecciones adicionales para personas vulnerables',
    priv_mdr2: 'Seguridad y rendimiento clínicos',
    priv_mdr3: 'Clara distinción entre detección y diagnóstico',
    priv_mdr4: 'Gestión ética de los datos de salud',
    priv_retentionTitle: 'Política de retención de datos',
    priv_12months: '12 meses',
    priv_12monthsDesc: 'Coordenadas de seguimiento ocular y pulsaciones',
    priv_24months: '24 meses',
    priv_24monthsDesc: 'Metadatos de análisis',
    priv_parentsControl: 'Control parental',
    priv_deleteAnytime: 'Eliminar en cualquier momento',

    mat_headline1: 'Empatía humana.',
    mat_headline2: 'Precisión artificial',
    mat_subheadline: 'Combinando experiencia vivida e IA de vanguardia para hacer que la detección de la dislexia sea',
    mat_subheadlineHighlight: 'accesible para todos',
    mat_whatTitle: 'Lo que hacemos',
    mat_what1: 'Combinamos una profunda experiencia en los patrones de lectura disléxica con tecnología de IA avanzada. Tras años de investigación, hemos enseñado estas ideas a una IA adaptativa.',
    mat_what2: 'Nuestra IA realiza pruebas inteligentes y multicapa: cada respuesta se compara con miles de patrones de lectura reales. Aprende en tiempo real y hace las preguntas de seguimiento adecuadas.',
    mat_what3: 'Para dar a las familias la claridad que necesitan para dar su próximo paso con confianza.',
    mat_whyTitle: 'Por qué lo hacemos',
    mat_why1: 'Imagina que tu hijo se enfrenta a los mismos retos de lectura que tú tuviste una vez, pero ahora sabes que tiene un nombre: dislexia. Quieres respuestas, pero la primera evaluación cuesta entre 750 y 1.800 euros, fuera del alcance de muchas familias.',
    mat_why2: 'Esa realidad nos parte el corazón. Cada niño merece entender cómo aprende. Cada padre merece respuestas.',
    mat_why3: 'Por eso estamos aquí: porque entender tu propia mente nunca debería ser un privilegio. Es un derecho humano.',
    mat_bgTitle: 'Nuestra experiencia',
    mat_bg1: 'Hemos vivido la dislexia de primera mano y nos hemos especializado en lectura accesible durante más de 20 años. Combinando esta experiencia vivida con la IA, hemos creado una herramienta de detección sencilla, asequible y que cambia vidas.',
    mat_bg2: 'Nuestra IA no solo mide la velocidad de lectura ni cuenta errores: entiende el "cómo" detrás de cada movimiento ocular, pausa y corrección.',
    mat_techTitle: 'Nuestra tecnología',
    mat_tech1: 'Al amplificar estas diferencias sutiles, nuestro sistema aprende a distinguir entre la dislexia y otros desafíos de lectura con una precisión extraordinaria. Utilizamos agrupamiento profundo, una forma avanzada de aprendizaje no supervisado.',
    mat_tech2: 'Este enfoque multicapa y de referencias cruzadas aporta más certeza que cualquier método anterior, con mayor profundidad que nunca.',
    mat_eyeTitle: 'Seguimiento ocular',
    mat_eyeText: 'Medimos la estabilidad de la mirada, la duración de las fijaciones y los movimientos sacádicos para saber cómo cambia el enfoque visual durante la lectura.',
    mat_kbdTitle: 'Dinámica del teclado',
    mat_kbdText: 'El ritmo de las pulsaciones de teclas, las vacilaciones y las correcciones revelan la secuenciación y los desafíos fonológicos característicos del perfil disléxico.',
    mat_ferTitle: 'Reconocimiento de expresiones faciales (FER)',
    mat_ferText: 'Las microexpresiones revelan frustración, compromiso o alivio, lo que permite a nuestra IA captar la capa emocional detrás del esfuerzo lector.',

    footer_about: 'Sobre nosotros',
    footer_blog: 'Publicaciones',
    footer_contact: 'Contacto',
    footer_faq: 'FAQ',
    footer_privacy: 'Privacidad',
    footer_terms: 'Términos del servicio',
    footer_tagline: 'Evaluación de dislexia impulsada por IA con seguimiento de iris en tiempo real, dinámica de teclado y análisis de expresión facial, disponible en 8 idiomas, completamente en el navegador.',
    footer_productHeading: 'Producto',
    footer_legalHeading: 'Legal',
    footer_mission: 'Creado para hacer que la detección de la dislexia sea accesible para todos, en cualquier idioma.',
    footer_copyright: 'Todos los derechos reservados',
    footer_madeWith: 'Creado con el propósito de concienciar sobre la dislexia',
    footer_allSystems: 'Todos los sistemas operativos',

    fp_assessmentBadge: 'Último paso',
    fp_feedbackTitle: 'Comparte una nota final',
    fp_feedbackDesc: 'Los comentarios opcionales nos ayudan a mejorar la experiencia de evaluación.',
    fp_shareThoughts: 'Comparte tus pensamientos',
    fp_optional: 'Opcional',
    fp_words: 'Palabras',
    fp_corrections: 'Correcciones',
    fp_speed: 'Velocidad',
    fp_feedbackPlaceholder: '¿Algo fue difícil, poco claro o mejorable?',
    fp_observationNotesTitle: 'Notas de observación (opcional)',
    fp_observationNotesDesc: 'Para el padre/madre o supervisor presente durante la prueba: cualquier cosa que notaras que la pantalla no puede ver — distracción, cansancio, llanto, ruido o cualquier otra cosa que valga la pena registrar junto con los resultados.',
    fp_observationNotesPlaceholder: 'p. ej. "Parecía cansado durante la prueba de escritura de palabras" o "Se distrajo con un hermano durante la Historia 1"',
    fp_generatingReport: 'Generando tu informe…',
    fp_submitBtn: 'Finalizar y ver informe',
    fp_skipHint: 'El comentario es opcional. Continúa cuando estés listo.',
    fp_youNailedIt: 'Evaluación completada',
    fp_reportGenerated: 'Tu informe está listo en el panel.',
    fp_copySentTo: 'Detalles de acceso enviados a',
    fp_welcomeBack: 'Informe guardado',
    fp_newReportAdded: 'Agregado a los resultados de tu panel.',
    fp_reportReady: 'Tu informe está listo',
    fp_reportSubtitle: 'Análisis completo, reproducción de seguimiento ocular e indicadores de dislexia',
    fp_openingReport: 'Abriendo tu informe…',
    fp_viewMyReport: 'Ver mi informe',
    fp_signInLater: 'O inicia sesión aquí más tarde',
    fp_saveForAccess: 'Guardar para acceso futuro',
    fp_emailLabel: 'Correo electrónico',
    fp_passwordLabel: 'Contraseña',
    fp_copied: 'Copiado',
    fp_copy: 'Copiar',
    fp_pwUpdated: 'Contraseña actualizada correctamente',
    fp_setCustomPw: 'Establecer contraseña personalizada',
    fp_newPwPlaceholder: 'Nueva contraseña (mínimo 4 caracteres)',
    fp_save: 'Guardar',
    fp_cancel: 'Cancelar',
    fp_signInLink: 'Abrir panel →',
    fp2_saving: 'Guardando tus resultados…',
    fp2_savingSub: 'Tarda unos segundos. Mantén esta página abierta.',
    fp2_allDone: 'Listo',
    fp2_reportReadySent: 'El informe está listo. Hemos enviado los datos de acceso a',
    fp2_reportReadyReturning: 'El informe está listo y se ha añadido a tu panel.',
    fp2_passwordLine: 'Tu contraseña (también en el correo):',
    fp2_openReport: 'Abrir el informe',
    fp2_saveFailed: 'Tus resultados aún no se han podido guardar.',
    fp2_saveFailedSub: 'Comprueba la conexión a internet y vuelve a intentarlo. Mantén esta página abierta.',
    fp2_tryAgain: 'Reintentar',
    fp2_sessionTitle: '¿Hay algo sobre la prueba que debamos saber?',
    fp2_sessionOptional: 'Opcional · no cambia el resultado',
    fp2_cTired: 'Cansado o distraído',
    fp2_cCameraMic: 'Problema con la cámara o el micrófono',
    fp2_cNoisy: 'Ruido o interrupciones',
    fp2_cLanguage: 'No es la primera lengua',
    fp2_cHelped: 'Alguien ayudó con las respuestas',
    fp2_cFroze: 'La página se bloqueó o hubo que recargarla',
    fp2_saveNotes: 'Guardar notas',
    fp2_notesSaved: 'Notas guardadas',
    fp2_notesFailed: 'No se pudieron guardar las notas. Inténtalo de nuevo.',
    fp_parentNote: '👨‍👩‍👧 Una nota para los padres',
    fp_parentNoteDesc: 'La evaluación ha concluido. Por favor, indica cómo le fue a tu hijo en las tareas de hoy (opcional).',
    fp_screeningResult: 'Resultado de la detección',
    fp_riskTypical: 'Típico: sin indicadores significativos',
    fp_riskBorderline: 'Limítrofe: algunos indicadores presentes',
    fp_riskHighRisk: 'Alto riesgo: varios indicadores encontrados',
    fp_riskVeryHighRisk: 'Riesgo muy alto: indicadores sólidos en todas las áreas',
    fp_confidence: 'Confianza',
    fp_keyFindings: 'Conclusiones clave',
    fp_disclaimer: 'Esta es solo una herramienta de detección, no un diagnóstico clínico. Consulta a un psicólogo educativo registrado para una evaluación completa.',
    fp_notAssessed: 'No evaluado',
    fp_percentile: 'percentil',
    fp_domainTypical: '✓ Típico',
    fp_domainBorderline: '⚠ Limítrofe',
    fp_domainHighRisk: '✗ Alto riesgo',
    fp_aiReportTitle: 'Informe personalizado de IA',
    fp_aiGenerating: 'DysTest AI está generando tu informe personalizado…',
    fp_aiGenerated: 'Generado por DysTest AI · No es un diagnóstico clínico',
    fp_aiAnalysing: 'Analizando los datos de la evaluación…',
    fp_strengths: 'Fortalezas',
    fp_areasToSupport: 'Áreas de apoyo',
    fp_noDifficulties: 'No se encontraron dificultades significativas.',
    fp_eyeTracking: 'Seguimiento ocular:',
    fp_recommendations: 'Recomendaciones',
    fp_nextStep: 'Próximo paso:',
    pp_title: 'Política de privacidad',
    pp_bannerTitle: 'Tu privacidad es sagrada',
    pp_bannerDesc: 'Creemos que tus datos personales son tuyos, no nuestros para vender. Solo almacenamos lo que es necesario para una detección precisa de la dislexia y lo protegemos con seguridad líder en el sector. Siempre tienes el control total de tu información.',
    pp_contactTitle: '¿Preguntas sobre tu privacidad?',
    pp_contactDesc: 'Estamos comprometidos con la transparencia. Si tienes alguna pregunta sobre cómo gestionamos tus datos, estamos aquí para ayudarte.',
    pp_privacyInquiries: 'Consultas de privacidad',
    pp_generalSupport: 'Soporte general',
    pp_acknowledgment: 'Al utilizar el servicio DysTest, reconoces que has leído y comprendido esta Política de privacidad.',
    tos_title: 'Términos del servicio',
    tos_missionTitle: 'Nuestra misión',
    tos_missionDesc: 'Comprender tu propia mente no debería ser un lujo, es un derecho humano. Nuestra misión es hacer que la detección de la dislexia sea accesible, asequible y precisa para cada familia.',
    tos_contactTitle: '¿Preguntas sobre estos términos?',
    tos_contactDesc: 'Estamos aquí para ayudarte. Si tienes alguna pregunta sobre nuestros Términos del servicio, no dudes en ponerte en contacto.',
    tos_acknowledgment: 'Al utilizar el servicio DysTest, reconoces que has leído, comprendido y aceptado quedar vinculado por estos Términos del servicio.',
    shared_quickNav: 'Navegación rápida',
    shared_backHome: '← Volver al inicio',
    shared_effectiveDate: 'Fecha de entrada en vigor: 30 de octubre de 2025',
    shared_lastUpdated: 'Última actualización: 30 de octubre de 2025',
    shared_footerTagline: 'Hacer que las pruebas de dislexia sean precisas, accesibles y asequibles.',
    shared_website: 'Sitio web',
    shared_email: 'Correo electrónico',
    blog_knowledgeBadge: 'Centro de conocimiento DysTest',
    blog_title: 'Blog de DysTest',
    blog_subtitle: 'Información experta sobre la dislexia, las dificultades de aprendizaje y cómo la IA está revolucionando la detección temprana y el apoyo',
    blog_searchPlaceholder: 'Buscar artículos sobre dislexia, dificultades de aprendizaje, evaluación con IA...',
    blog_catAll: 'Todos',
    blog_catUnderstanding: 'Entender la dislexia',
    blog_catEarlyDetection: 'Detección temprana',
    blog_catTechnology: 'Tecnología',
    blog_catNews: 'Noticias',
    blog_featuredBadge: '⭐ Destacado',
    blog_featuredArticles: 'Artículos destacados',
    blog_allArticles: 'Todos los artículos',
    blog_article: 'artículo',
    blog_articles: 'artículos',
    blog_readMore: 'Leer más →',
    blog_found: 'Encontrado',
    blog_forQuery: 'para',
    blog_noResults: 'No se encontraron artículos',
    blog_noResultsDesc: 'Intenta ajustar tu búsqueda o los criterios de filtrado',
    blog_clearFilters: 'Borrar filtros y mostrar todos los artículos',
    blog_newsletterTitle: 'Mantente al día sobre la investigación de la dislexia',
    blog_newsletterDesc: 'Recibe la última información sobre investigación de la dislexia, tecnología de IA y estrategias de aprendizaje en tu bandeja de entrada.',
    blog_newsletterBtn: 'Suscribirse para actualizaciones',
    blog_newsletterPrivacy: 'Sin spam. Cancela la suscripción en cualquier momento. Respetamos tu privacidad.',
    blog_newsletterEmailPlaceholder: 'Introduce tu correo electrónico',
    blog_newsletterSending: 'Enviando…',
    blog_newsletterCheckInbox: 'Casi listo: revise su bandeja de entrada y haga clic en el enlace para confirmar.',
    blog_newsletterError: 'Algo salió mal. Inténtelo de nuevo más tarde.',
    nws_working: 'Un momento…',
    nws_confirmedTitle: 'Está suscrito',
    nws_confirmedBody: '¡Gracias! Recibirá nuevas entradas del blog, documentos técnicos y nuestro boletín. Cada correo incluye un enlace para darse de baja.',
    nws_wasUnsubscribed: 'Esta dirección se dio de baja. Suscríbase de nuevo en el blog para recibir novedades.',
    nws_unsubTitle: '¿Darse de baja de las novedades de DysTest?',
    nws_unsubBody: 'Ya no recibirá nuevas entradas del blog, documentos técnicos ni el boletín.',
    nws_unsubBtn: 'Darse de baja',
    nws_unsubDoneTitle: 'Se ha dado de baja',
    nws_unsubDoneBody: 'No recibirá más novedades. ¿Cambió de opinión? Puede volver a suscribirse en el blog.',
    nws_invalidTitle: 'Este enlace no es válido',
    nws_invalidBody: 'Puede que el enlace sea antiguo o esté incompleto. Puede volver a suscribirse en el blog.',
    nws_toBlog: 'Ir al blog',
    blog_backToArticles: 'Volver a los artículos',
    blog_loadingArticle: 'Cargando artículo...',
    blog_articleNotFound: 'Artículo no encontrado',
    blog_ctaTitle: '¿Listo para saber más?',
    blog_ctaDesc: 'Descubre cómo DysTest puede identificar las dificultades de aprendizaje con nuestra evaluación impulsada por IA y desbloquear el potencial de cada niño.',
    blog_tryDystest: 'Probar la evaluación DysTest',
    blog_readMoreArticles: 'Leer más artículos',
    faq_badge: '¿Tienes preguntas? Tenemos respuestas',
    faq_title: 'Preguntas frecuentes',
    faq_subtitle: 'Sobre nuestra',
    faq_subtitleHighlight: 'Detección de dislexia con seguimiento ocular',
    faq_searchPlaceholder: "Buscar preguntas... (p. ej., 'coste', 'privacidad', 'cuánto tiempo')",
    faq_mostPopular: 'Preguntas más populares',
    faq_noResults: 'No se encontraron preguntas que coincidan con tu búsqueda.',
    faq_clearFilters: 'Borrar filtros',
    faq_stillHave: '¿Todavía tienes preguntas?',
    faq_supportDesc: 'Nuestro equipo de soporte está aquí para ayudarte. Normalmente respondemos en 24 horas.',
    faq_contactSupport: 'Contactar con el soporte',
    faq_startScreening: 'Iniciar la detección',
    faq_catAll: 'Todos',
    faq_related: 'Relacionados:',
    about_badge: 'Nuestra historia',
    about_title: 'Sobre DysTest',
    about_subtitle: 'Creemos que cada niño merece ser comprendido, no solo evaluado.',
    about_backHome: '← Volver al inicio',
    about_ctaTitle: '¿Listo para empezar?',
    about_ctaDesc: 'Inicia hoy una detección compasiva para tu hijo y descubre cómo DysTest desbloquea el potencial de cada aprendiz.',
    about_startScreening: 'Iniciar la detección',
    about_startAssessment: 'Comenzar',
    about_navWhy: 'Por Qué Existe DysTest',
    about_navMissionValues: 'Misión y Valores',
    about_navTechnology: 'Tecnología',
    about_navTeam: 'Las Personas Detrás de DysTest',
    ran_audio_preLetter: 'Denominación de letras. Lee en voz alta cada letra de cada fila, lo más rápido que puedas.',
    ran_audio_preDigit: 'Ahora los dígitos. Lee en voz alta cada número de cada fila, lo más rápido que puedas.',
    ran_audio_preColor: 'Ahora los colores. Di en voz alta el color de cada cuadrado, lo más rápido que puedas.',
    ran_audio_preObject: 'Ahora los objetos. Di en voz alta el nombre de cada imagen, lo más rápido que puedas.',
    ran_audio_runLetter: 'Lee cada letra en voz alta lo más rápido que puedas.',
    ran_audio_runDigit: 'Lee cada número en voz alta lo más rápido que puedas.',
    ran_audio_runColor: 'Di el color de cada cuadrado en voz alta lo más rápido que puedas.',
    ran_audio_runObject: 'Di el nombre de cada imagen en voz alta lo más rápido que puedas.',
    ran_audio_practice: 'Practiquemos. Di cada letra en voz alta.',
    ran_intro_t1_heading: '¡Digamos algunas letras! 🔤',
    ran_intro_t1_desc1: 'Verás letras grandes en la pantalla.',
    ran_intro_t1_desc2: '¡Di cada una en voz alta lo más rápido que puedas!',
    ran_intro_heading: 'RAN',
    ran_intro_desc1: 'Verás filas de letras, dígitos, colores y objetos. Lee cada fila en voz alta lo más rápido que puedas, de izquierda a derecha.',
    ran_intro_desc2: 'El evaluador pasará a la siguiente fila después de que completes cada una. Primero haremos una breve práctica.',
    ran_intro_labLetters: 'Letras',
    ran_intro_labDigits: 'Dígitos',
    ran_intro_labColors: 'Colores',
    ran_intro_labObjects: 'Objetos',
    ran_practice_t1_heading: '¿Puedes decir estos? 👀',
    ran_practice_heading: 'Práctica',
    ran_practice_t1_desc: 'Di cada letra en voz alta. ¡Empieza por la izquierda!',
    ran_practice_desc: 'Lee esta fila de letras en voz alta, de izquierda a derecha. El evaluador pasará a la siguiente fila cuando hayas terminado.',
    ran_practice_hint: 'Di: "a · o · s · p · k", luego pulsa el botón de abajo.',
    ran_btn_try: '¡Vamos a intentarlo! 🎉',
    ran_btn_practise: 'Vamos a practicar',
    ran_btn_skip: 'Omitir',
    ran_btn_gotIt: 'Entendido: empezar con las letras →',
    ran_btn_begin: 'Empezar: leer la fila 1 →',
    ran_btn_nextRow: 'Siguiente fila',
    ran_btn_continue: 'Continuar',
    ran_preLetter_title: 'Denominación de letras (RAN-L)',
    ran_preLetter_subtitle: '50 letras · 5 filas de 10. Lee cada fila en voz alta lo más rápido que puedas.',
    ran_preLetter_detail: 'El evaluador pulsará la siguiente fila después de cada una.',
    ran_preLetter_btn: 'Mostrar cuadrícula →',
    ran_preDigit_title: '¡Letras listas! Ahora los dígitos (RAN-D)',
    ran_preDigit_subtitle: 'La misma tarea con dígitos: 2 · 4 · 5 · 7 · 8',
    ran_preDigit_detail: '50 dígitos · 5 filas de 10 · las mismas reglas.',
    ran_preDigit_btn: 'Empezar con los dígitos →',
    ran_preColor_title: '¡Dígitos listos! Ahora los colores (RAN-C)',
    ran_preColor_subtitle: 'Di el color de cada cuadrado en voz alta, lo más rápido que puedas.',
    ran_preColor_detail: '50 cuadrados de colores · 5 filas de 10 · las mismas reglas.',
    ran_preColor_btn: 'Empezar con los colores →',
    ran_preObject_title: '¡Colores listos! Ahora los objetos (RAN-O)',
    ran_preObject_subtitle: 'Di el nombre de cada imagen en voz alta, lo más rápido que puedas.',
    ran_preObject_detail: '50 objetos · 5 filas de 10 · las mismas reglas.',
    ran_preObject_btn: 'Empezar con los objetos →',
    ran_done_t1_heading: '¡Trabajo fantástico! 🌟',
    ran_done_heading: '¡Todas las tareas de denominación completadas!',
    ran_done_t1_desc: '¡Has dicho todas las letras!',
    ran_done_desc: 'Aquí están los resultados:',
    ran_badge: 'Prueba de denominación rápida',
    ran_intro_watchDemo: '👀 Ve cómo funciona',
    ran_intro_t1_lead: 'Mira cada letra y dila en voz alta lo más rápido que puedas, ¡de izquierda a derecha!',
    ran_intro_step1: 'Mira la fila',
    ran_intro_step2: 'Di cada una en voz alta',
    ran_intro_step3: '¡Ve tan rápido como puedas!',
    ran_intro_demoLabel: '¡Di cada elemento en voz alta lo más rápido que puedas!',
    ran_btn_start: 'Empezar 🚀',
    ran_btn_tapStart: 'Haz clic para empezar la fila 1',
    ran_btn_listening: 'Escuchando…',
    ran_btn_repeat: 'Repetir instrucciones',
    ran_processing: 'Procesando…',
    ran_transcribing: 'Transcribiendo audio con Whisper…',
    ran_transcribingDesc: 'Analizando la precisión del habla: tarda unos segundos',
    ran_stat_totalTime: 'Tiempo total',
    ran_stat_itemsPerSec: 'Elementos/s',
    ran_stat_avgItem: 'Elemento medio',
    ran_stat_mistakes: 'Errores',
    ran_paceHint: 'Resaltado = fila actual · El evaluador controla el ritmo',
    ran_running_letter: '🔤 RAN-L — Letras',
    ran_running_digit: '🔢 RAN-D — Dígitos',
    ran_running_color: '🎨 RAN-C — Colores',
    ran_running_object: '🦎 RAN-O — Objetos',
    ran_header_letter: 'RAN-L',
    ran_header_digit: 'RAN-D',
    ran_header_color: 'RAN-C',
    ran_header_object: 'RAN-O',

    nav_home: 'Inicio',
    nav_about: 'Sobre nosotros',
    nav_resources: 'Recursos',
    nav_startAssessment: 'Iniciar evaluación',
    nav_langMenuTitle: 'Idioma de la evaluación',
    nav_langMenuHint: 'Las historias y las instrucciones siguen este idioma',
    nav_techPapers: 'Artículos Técnicos',
    nav_blog: 'Blog',
    nav_guides: 'Guías',
    nav_faq: 'Preguntas frecuentes',

        wwt_badge: 'Prueba de escritura de palabras',
    wwt_introTitle: 'Recuerda y escribe la palabra',
    wwt_introDesc: 'Una palabra aparece durante 5 segundos — luego se borra letra por letra y la escribes de memoria',
    wwt_demoHint: 'La palabra desaparece — la escribes de memoria',
    wwt_startWriting: '¡Empieza a escribir!',
    wwt_rememberWord: 'Recuerda esta palabra',
    wwt_watchCountdown: 'Mira la cuenta atrás — luego escríbela de memoria',
    wwt_typeWord: 'Escribe la palabra que viste',
    wwt_pressEnter: 'Escríbela y pulsa Enter o Siguiente',
    wwt_nextWord: 'Siguiente palabra',
    wwt_finish: 'Terminar',
    wwt_done: '¡Bien hecho!',
    wwt_correct: 'palabras correctas',
    wwt_continue: 'Continuar',
    wwt_wordOf: 'Palabra {current} de {total}',
    form_badgeText: 'Paso 1/8: Regístrate',
    form_heading: 'Regístrate y empieza',
    form_privacyNote: 'Tus datos están protegidos por el RGPD y el MDR. No se comparte ninguna información personal identificable con terceros.',

    // ── Microphone check panel (mic_*) ───────────────────────────────────
    mic_title: 'Verificación del micrófono',
    mic_sub_checking: 'Comprobando el micrófono…',
    mic_sub_ready: 'Micrófono listo — toca Probar para grabar',
    mic_sub_recording: 'Grabando… habla ahora',
    mic_sub_retry: 'No te hemos escuchado bien — inténtalo de nuevo',
    mic_sub_passed: '¡El micrófono funciona perfectamente!',
    mic_sub_denied: 'Acceso al micrófono denegado',
    mic_pleaseSpeak: '🗣️ Habla ahora, por favor…',
    mic_retryBody: 'No pudimos escucharte con claridad. Habla un poco más alto e inténtalo de nuevo.',
    mic_testBtn: 'Probar micrófono',
    mic_tryAgain: 'Intentar de nuevo',
    mic_continueBtn: 'Continuar',
    mic_skipDenied: 'Omitir (sin micrófono)',
    mic_skip: 'Omitir verificación del micrófono',
    ud_myDashboard: 'Mi panel',
    ud_myAssessmentReports: 'Mis informes de evaluación',
    ud_noAssessmentsFound: 'No se encontraron evaluaciones completadas.',
    ud_assessmentsFoundSingular: '1 evaluación completada encontrada.',
    ud_assessmentsFoundPlural: '{n} evaluaciones completadas encontradas.',
    ud_loadError: 'No se pudieron cargar sus evaluaciones. Compruebe su conexión y recargue la página.',
    ud_serviceUnavailable: 'El servidor no está disponible temporalmente (503). Por favor, espere un momento y actualice la página.',
    ud_progressOverTime: 'Progreso a lo largo del tiempo',
    ud_longitudinalSubtitle: '{n} evaluaciones · tendencia de puntuación z compuesta',
    ud_typical: 'Típico (z ≥ −0,5)',
    ud_borderline: 'Límite (z < −0,5)',
    ud_highRisk: 'Alto riesgo (z < −1,0)',
    ud_veryHighRisk: 'Riesgo muy alto (z < −1,5)',
    ud_noAssessmentsFor: 'No se encontraron evaluaciones para',
    ud_completeAssessment: 'Complete una evaluación para ver sus resultados aquí.',
    ud_startAssessment: 'Iniciar una evaluación',
    ud_assessmentReport: 'Informe de evaluación',
    ud_completed: 'Completado',
    ud_accuracy: 'PRECISIÓN',
    ud_blinks: 'PARPADEOS',
    ud_questions: 'PREGUNTAS',
    ud_rawData: 'Datos sin procesar (JSON)',
    ud_tabEyeTracking: 'Seguimiento ocular',
    ud_tabRan: 'Análisis RAN',
    ud_tabStory: 'Análisis de historias',
    ud_gazePlaybackTitle: 'Reproducción de seguimiento ocular — 3 modos: Cuadrícula · Mapa de calor · Trayectoria',
    ud_noGazeData: 'No hay datos de seguimiento ocular disponibles para esta evaluación.',
    ud_gazeDataNote: 'Los datos de seguimiento ocular se capturan durante la sesión de evaluación en vivo y se almacenan con el informe.',
    ud_ranTitle: 'RAN — Resultados de denominación automatizada rápida',
    ud_totalTime: 'Tiempo total',
    ud_rawSpeed: 'Velocidad bruta',
    ud_correctedSpeed: 'Velocidad corregida',
    ud_errors: 'Errores',
    ud_rowTimings: 'Tiempos por fila',
    ud_transcriptComparison: 'Comparación de transcripción',
    ud_row: 'Fila',
    ud_audioNote: 'La reproducción de audio está disponible en el informe ZIP completo · Descargar informe completo (ZIP) arriba',
    ud_storyTitle: 'Análisis de lectura de historia',
    ud_story1Label: 'Historia 1 — Fase de lectura',
    ud_story2Label: 'Historia 2 — Fase de lectura',
    ud_readingTime: 'Tiempo de lectura',
    ud_fixations: 'Fijaciones',
    ud_regressions: 'Regresiones',
    ud_avgFixation: 'Fijación prom.',
    ud_saccades: 'Sacadas',
    ud_blinkRate: 'Tasa de parpadeo',
    ud_gazeStoryTitle: 'Seguimiento ocular — Páginas de historia',
    ud_noStoryGaze: 'Datos de seguimiento ocular de historia no disponibles para esta evaluación.',
    ud_footer: 'Sus datos se almacenan de forma segura solo en este dispositivo.',
    ud_changePassword: 'Cambiar contraseña',
    ud_changePasswordDesc: 'Establezca una nueva contraseña para su cuenta. La usará la próxima vez que inicie sesión.',
    ud_passwordUpdated: 'Contraseña actualizada correctamente',
    ud_newPasswordPlaceholder: 'Nueva contraseña (mín. 4 caracteres)',
    ud_saving: 'Guardando…',
    ud_saveNewPassword: 'Guardar nueva contraseña',
    ud_passwordTooShort: 'La contraseña debe tener al menos 4 caracteres.',
    ud_passwordUpdateFailed: 'No se pudo actualizar su contraseña. Por favor, inténtelo de nuevo.',
    ud_accuracySuffix: 'precisión',
    acp_tabCamera: 'Cámara',
    acp_tabKeyboard: 'Teclado',
    acp_tabMicrophone: 'Micrófono',
    acp_checkingCameraQuality: 'Verificando la calidad de la cámara — esto toma unos segundos',
    acp_allChecksPassed: '¡Todas las verificaciones pasaron!',
    acp_allSystemsReady: 'Cámara, teclado y micrófono están listos.',
    mini_step: 'Paso',
    scp_setupComplete: '🎉 ¡Configuración completa!',
    scp_allSetSubtitle: 'Estás listo para la evaluación de dislexia',
    scp_setupQualityScore: 'Puntuación de calidad de configuración',
    scp_excellentSetup: 'Excelente calidad de configuración para una evaluación precisa',
    scp_completedSteps: '✅ Pasos completados',
    scp_cameraReadiness: 'Preparación de la cámara',
    scp_cameraStabilityPassed: 'Verificación de estabilidad de 10 segundos superada',
    scp_keyboardCapture: 'Captura del teclado',
    scp_keystrokeData: 'Datos clínicos de pulsaciones capturados',
    scp_eyeCalibration: 'Calibración ocular',
    scp_calibrationCompleted: 'Calibración completada ({pct}% de precisión)',
    scp_whatsNext: '¿Qué sigue?',
    scp_whatsNextBody: 'Comenzarás la evaluación de lectura donde analizaremos tus movimientos oculares, expresiones faciales y patrones de lectura para proporcionar un cribado integral de dislexia.',
    scp_startAssessment: 'Iniciar evaluación de dislexia',
    scp_startingAssessment: 'Iniciando evaluación...',
    scp_estimatedTime: 'Tiempo estimado: 10-15 minutos',

    // Cuadrícula de informes UserDashboard
    ud_view: 'Ver',
    ud_report_userInfo: 'Información del usuario',
    ud_report_envSetup: 'Configuración del entorno',
    ud_report_wordIcon: 'Asociación palabra-icono',
    ud_report_ran: 'Análisis RAN',
    ud_report_story: 'Análisis de historia',
    ud_report_wordWriting: 'Escritura de palabras',
    ud_report_feedback: 'Retroalimentación',
    ud_report_summary: 'Resumen',
    ul_platform: 'Plataforma de evaluación de dislexia',
    ul_invalidCredentials: 'Correo electrónico o contraseña no válidos. Revisa las credenciales mostradas al final de tu evaluación.',
    ul_loginFailed: 'Error al iniciar sesión. Inténtalo de nuevo.',
    ul_resetFailed: 'Algo salió mal. Inténtalo de nuevo.',
    ul_backToSignIn: 'Volver a iniciar sesión',
    ul_checkEmail: 'Revisa tu correo',
    ul_smtpDevNotice: 'SMTP no configurado (dev). Contraseña temporal:',
    ul_resetSent: 'Si {email} está registrado, recibirás una nueva contraseña.',
    ul_signIn: 'Iniciar sesión',
    ul_resetPassword: 'Restablecer contraseña',
    ul_resetPasswordDesc: 'Introduce tu correo y te enviaremos una nueva contraseña.',
    ul_emailAddress: 'Correo electrónico',
    ul_emailPlaceholder: 'tu@email.com',
    ul_sending: 'Enviando…',
    ul_sendNewPassword: 'Enviar nueva contraseña',
    ul_welcomeBack: 'Bienvenido de nuevo',
    ul_signInSubtitle: 'Inicia sesión para ver tus resultados de evaluación',
    ul_password: 'Contraseña',
    ul_passwordPlaceholder: 'Tu contraseña',
    ul_hidePassword: 'Ocultar contraseña',
    ul_showPassword: 'Mostrar contraseña',
    ul_forgotPassword: '¿Olvidaste tu contraseña?',
    ul_signingIn: 'Iniciando sesión…',
    ul_signInDashboard: 'Entrar a tu panel',
    ul_firstTime: '¿Primera vez aquí? Tu cuenta se creó automáticamente después de tu evaluación. Revisa tu correo para ver los datos de acceso.',
    ul_footer: 'Cumple con RGPD y MDR · No se almacena video',

    mg_title: '¡Un poco de paciencia, por la ciencia!',
    mg_body: 'DysTest analiza los movimientos de tus ojos (¡al píxel!), tu velocidad al escribir y tu voz al milisegundo.\n\nUna tecnología superinteligente, pero tiene un punto débil: no funciona mientras la pantalla se mueve en tu mano. ¡Así que abre un portátil o un ordenador para obtener un resultado fiable!',
    mg_howTo: 'Cómo empezar',
    mg_step1: 'Abre dystest.com en un portátil o un ordenador de sobremesa',
    mg_step2: 'Asegúrate de que la webcam y el teclado estén conectados',
    mg_step3: 'Usa Chrome o Firefox para obtener los mejores resultados',
    mg_returnHome: 'Volver a la página de inicio',
    mg_shareLink: 'Enviarme el enlace',
    mg_copyLink: 'Copiar enlace',
    mg_linkCopied: 'Enlace copiado',
    mg_alreadyDone: '¿Ya hizo una prueba?',
    mg_loginLink: 'Inicie sesión para ver el informe',
    mg_emailLabel: 'Su correo electrónico',
    mg_emailPlaceholder: 'nombre@ejemplo.es',
    mg_emailSend: 'Enviar',
    mg_emailSent: '¡Enviado! Abra el correo en su portátil u ordenador para empezar la prueba.',
    mg_emailError: 'No se pudo enviar el correo. Revise la dirección e inténtelo de nuevo.',
};

export default es;
